import React from 'react';
import {Helmet} from 'react-helmet';
import { store } from '../../../store';

import Tasknav from '../Tasknav'

import Save from '../Save'

import AboutSection from '../Sections/About/AboutSection'

import Profile from '../Sections/Profile/Profile'

import CustomizationPanel from '../Sections/Customization/CustomizationPanel'

import Controller from '../Sections/Customization/Controller'

import LinksFunction from '../Sections/SocialLinks/LinksFunction'
import LinksSection from '../Sections/SocialLinks/LinksSection'

import ImageUploadFunction from '../Sections/Images/ImageUploadFunction'
import {ProPic, CoverImageURL} from '../Sections/Images/ImageSection'

import Menu from '../../Navigation/Menu'

const Fourth = ({onUser, onEdit, onOpen, onRouteChange, onWebsitename, onWebsiteBio, onCustomization, onSelectToolbar, onHighlight, onMenu, highlight, menu, handleOffClick, onClickInside, onClickOutside, onController, controller, profile_name, profile_bio, about, icons, background,onOuterDiv,onInnerDiv, outerdiv}) => {

  return ( 
<div id="scroll" className="editSection">          
<Helmet>
<meta name="viewport" content="width=device-width,initial-scale=1" />
<link href="https://fonts.googleapis.com/css?family=Coiny:400,700,700i|Dancing+Script:400,700,700i|Indie+Flower:400,700,700i|Lato:400,700,700i|Lobster+Two|Merriweather:400,700,700i|Open+Sans:400,700,700i|Pacifico:400,700,700i|Righteous:400,700,700i|Shadows+Into+Light+Two|Lora:400,700|Vibur:400,700,700i|Oswald:400,700|Roboto+Mono:400,700|Roboto:400,700,900|Abel" rel="stylesheet" />
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
<style type="text/css">{`
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
h1 {
  font-size:50px;
}
.wrap {
  display:flex;
  flex:2;
  margin:0;
  padding:0;
  width:99.5vw;
  overflow-x:aria-hidden;
  flex-direction: row-reverse;
  overflow-y: auto;
  background: ${background.color};
}
.bg_img {
  position:fixed;
  max-width:100%;
  max-height:100%;
  left:0;
  top:0;
  right:0;
  bottom:0;
  object-fit: cover;
  opacity: ${background.opacity};
}
.bg_img_inside {
  max-width: 100%;
  min-height: 100vh;
  object-fit: cover;
}
.head {
  display: flex;
  margin:0;
  flex:1;
  z-index: 0;
}
.img_section {
  height: 100vh;
  flex:1;
}
.main {
  display: flex;
  position: fixed;
  flex-wrap: wrap;
  height: 100vh;
  width:50vw;
  max-width:100%;
}
.img_thumb {
  width: 100%;
  height: 100%;
  transition: .4s ease-in-out;
  object-fit: cover;
}
.profile-card {
  animation: 1s ease-in-out 0s 1 fadeIn;
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content: center;
  min-height: 75%;
  padding: 5em;
  width:100%;
}

.profile {
  margin:1em 0;
  text-align: left;
  width:100%;
}
.profile_name {
  font-family: ${profile_name.font};
  text-transform: capitalize;
  font-size:${profile_name.size}px;
  color:${profile_name.color};
  display: block;
  min-width: 50%;
  line-height:1.5em;
}
.profile_desc {
  line-height:1em;
  font-family:${profile_bio.font};
  color:${profile_bio.color};
  min-width: 50%;
  font-size:${profile_bio.size}px;
}
.social_media {
  margin-top:2em;
  text-align: left;
  width:100%;
}
.socialicon, .socialicon:hover {
  font-size:22px;
  color:${icons.color};
  background: transparent;
  border-radius: 10px;
  text-align: center;
  margin:0.2em .8em 0em 0em;
  text-decoration: none;
}
.about {
  font-family:${about.font};
  font-size:${about.size}px;
  width:100%;
  margin-top:1.5em;
  min-height:5em;
  color:${about.color};
}
.paragraph,
p {
font-family: ${about.font};
color:${about.color};
margin-bottom:1em;
font-size:${about.size}px;
line-height:1.8;
}
p a {
text-decoration:underline;
color:${about.color};
}
p a:hover {
text-decoration:underline;
color:${about.color};
}
.nothing {
  display: hidden;
}
@media only screen and (max-width : 992px) {
body {
  overflow: visible;
}
.profile-card {
  padding:5em 2em;
}
.main {
  position: relative;
  height: 50vh;
  width:100vw;
}
.img_section {
  position: relative;
  height: ${ProPic() === null ? "0" : "50vh"};
}
.wrap {
  display:block;
}
.profile-card {
  position:relative;
  margin-left:auto;
  margin-right: auto;
}
}
`}</style>
</Helmet>
{(store.getState().activities.edit)         
? <div className="toptoolbar">
	<Tasknav
	onRouteChange={onRouteChange}
	onEdit={onEdit}
	onOpen={onOpen}
	onHighlight={onHighlight}
	highlight={highlight}
	onClickInside={onClickInside}
    onClickOutside={onClickOutside}
	/><span className="navmargin"><br /><br /><br /></span></div>
: null
}
<div className='wrap'>
<div className="bg_img">
{CoverImageURL() === null
  ? null
  : <img className="bg_img_inside" src={CoverImageURL()} alt="Background" />
}
</div>
{console.log(ProPic())}
<div className="img_section">
<div className="main">
{(store.getState().activities.edit)  
? <div className="img_thumb select" onClick={(open)=>
  {
  onOpen('propic')
  }}><i class="fa fa-camera img_edit_top_dp" aria-hidden="true"></i><img alt="dp" src={ProPic()} className="img_thumb"/></div>
: ProPic() !== null
  ? <img alt="dp" src={ProPic()} className="img_thumb"/>
  : null
}
</div>
</div>
<div className="head">
{(store.getState().activities.edit)  
? <span onClick={
  (open,select)=>
  {
  if(store.getState().activities.edit && outerdiv) {
  onOpen('cover')
  }
  }}  className="img_edit_cover"><i className="fa fa-camera img_edit_cover_icon" aria-hidden="true"></i> Upload</span>
: null
}
<div className="profile-card"
onMouseOver = {onInnerDiv.bind()}
onMouseOut = {onOuterDiv.bind()}>
<div className="profile">
<div className={
	store.getState().activities.edit
	? 'select_col'
	: ''
}>
<Profile onWebsitename={onWebsitename} onWebsiteBio={onWebsiteBio} onHighlight={onHighlight} highlight={highlight} />
<Controller
	onOpen={onOpen}
	onSelectToolbar={onSelectToolbar}
/>
</div>
</div>
<div className={
  store.getState().activities.edit
  ? 'about select_col'
  : 'about'
}>
<AboutSection/>
</div>
<div className="social_media">
<LinksFunction 
  onClickInside={onClickInside}
  onClickOutside={onClickOutside}
  alignCenter={'true'}/>        
<LinksSection onOpen={onOpen}/>
{(store.getState().activities.edit) 
? <span class="fa fa-plus addnew socialicon" onClick={(open)=>{onOpen('links')}}></span>
: null
}
</div>
</div>
</div>
</div>
{highlight === 'save'     
? <Save onHighlight={onHighlight} />
: null
}
{(!store.getState().activities.edit)         
?<span className="editbtn" onClick={(edit,open)=>{
onEdit(true)
onOpen(null)
onHighlight(null)
}}>Edit</span>
:<span />
}
{store.getState().activities.open === 'menu'
? <Menu
	onOpen={onOpen}
	onRouteChange={onRouteChange} 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>
: null
}
<CustomizationPanel 
	onEdit={onEdit}
	onOpen={onOpen}
	onSelectToolbar={onSelectToolbar}
	onCustomization={onCustomization}
	onClickInside={onClickInside}
    onClickOutside={onClickOutside} />
<ImageUploadFunction 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>
</div>
  )
}

export default Fourth